import hexagonalToEaseOfChange from "./hexagonal-to-ease-of-change.png";
import hierarchyTop from "./hierarchy-top.png";
import hierarchy from "./hierarchy.png";
import croppedRiver from "./cropped-river.png";

const content = `<p>Welcome to the <strong>World of Software Design!</strong></p>

<p>This resource will help you learn many design principles and techniques by clicking on the items on the map. And by looking at the rivers on the map, you'll understand how all the design principles are connected.</p>

<p>For example, let's start with the goal of software design: making code <a href="/ease-of-change">easy to change</a>.</p>

<p>There are several ways to achieve ease of change:</p>

<img src=${hierarchyTop} alt="hierarchy top" />

<p>In turn, each of those ways has several ways to achieve it, and so on:</p>

<img src=${hierarchy} alt="hierarchy" />

<p>Some design concepts are very general and some are merely ways to achieve the general concepts. For example, <a href="/hexagonal-architecture">Hexagonal Architecture</a> is a way to achieve <a href="/protected-variation">Protected variation</a>, which is itself a way to achieve <a href="/low-coupling">Low coupling</a>, which is itself a way to make the code <a href="/ease-of-change">easy to change</a>:</p>

<img src=${hexagonalToEaseOfChange} alt="hexagonal-to-ease-of-change" />

<h2>How to read the map</h2>

<p><span style="font-size: revert; color: initial; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Oxygen-Sans, Ubuntu, Cantarell, &quot;Helvetica Neue&quot;, sans-serif;">A rivers flowing from A to B means that A achieves B</span>. As in the above example Hexagonal architecture helps achieve Protected variation, which helps achieve Low coupling, which helps achieve ease of change, so the river water is flowing in that direction:</p>

<img src=${croppedRiver} style="filter:brightness(1.25)" alt="cropped-river" />

<p>All the rivers end up in the same sea: Ease of change, which is the goal of software design.</p>

<p>Click on any item on the map (including the Ease of change sea) to read an article on the corresponding concept.</p>

<h2>What's special about this resource</h2>

<p>The World of Software Design approaches software design with the following specificities:</p>

<ul><li>it shows the connections between design concepts</li><li>it shows which concepts are the most important</li><li>the articles gives a <strong>very concise</strong> but precise explanation on each concept</li><li>lots of its example are taken and adapted from production code where they helped in practice</li><li>the examples are written in Ruby (although they mostly don't use Ruby specificities) to show that we can make software design even in untyped languages where types and interfaces are not explicitly written in code.</li></ul>

<p>However, here is what the World of Software Design is not:</p>

<ul><li>it's not a comprehensive list of concepts. They're concepts that I've learned so far and that I found to be the most common and important. If you see something blatantly missing you're welcome to let me know!</li><li>it's not objective. The connections between the concepts are my mental model of software design. However the contents of the articles are factual and objective.</li>

<p>Big thanks to my colleagues at Doctolib who reviewed the articles, in particular to Loïc Knuchel, Mickael Tavares and Sam Lukes for their extensive and thorough reviews.</li></ul>

<h2>About the author</h2>

<p>My name is Jonathan Boccara. I've been a software developer for a bit more than 10 years now.</p>

<p>I'm an architect at <a href="https://www.doctolib.fr/">Doctolib</a>, a large healthcare European website (our software operates medical practices and allows patients to manage their health). I help teams master their code and tests by applying software design.</p>

<p>I held a blog on <a href="https://www.fluentcpp.com">expressive code in C++</a> for many years. I've also written a book on <a href="https://leanpub.com/legacycode">how to be happy and efficient with legacy code</a>.</p>

<p>I made another map, on the algorithms of the C++ standard library, which I presented at <a href="https://www.youtube.com/watch?v=2olsGf6JIkU">this conference</a>.</p>

<p>My areas of expertise are software design, crafting expressive code, DDD, working with legacy code and testing strategies.</p>

<p>You're welcome to <a href="mailto:jonathan@fluentcpp.com">get in touch</a> for feedback.</p>`;

export default content;
